'use client';

// ОБЩИЙ НИЖНИЙ ЛИСТ кабинета (владелец 2026-07-26: «эту нижнюю шторку сделай отдельным
// компонентом — и для всех уточнений „точно выйти“, „точно удалить“, и для выбора темы;
// там должен быть крестик закрыть, элементы управления как в классической айфонской
// нижней шторке»). Один компонент, разное содержимое.
//
// Устройство — как у родного листа iOS: затемнение позади (тап мимо закрывает), лист снизу
// со скруглённым верхом, грабер-полоска и КРЕСТИК слева в строке-шапке, заголовок по центру.
// Рисуется СВОИМ оверлеем поверх живого экрана (портал в .cab — там переменные темы), а НЕ
// нативным слоем: слой прятал текущую шторку в display:none и на возврате она собиралась
// заново — экран дёргался (видео владельца 2026-07-25).
import { useCallback, useEffect, useState, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { useTranslations } from 'next-intl';
import { KBareButton } from '@scriptera/ui/kit';

export function BottomSheet({
  title,
  onClose,
  children,
}: {
  /** Заголовок строки-шапки (по центру). Без него шапка — только крестик. */
  title?: string;
  onClose: () => void;
  /** Содержимое. Функцией — получает анимированное закрытие (кнопки внутри листа обязаны
   *  звать именно его, иначе лист исчезает без выезда вниз). */
  children: ReactNode | ((close: () => void) => ReactNode);
}) {
  const t = useTranslations('cabinet');
  const [show, setShow] = useState(false);
  // Кадр на монтирование в закрытой точке — иначе выезда снизу не видно.
  useEffect(() => {
    const id = requestAnimationFrame(() => setShow(true));
    return () => cancelAnimationFrame(id);
  }, []);
  const close = useCallback(() => {
    setShow(false);
    setTimeout(onClose, 560); // дать листу уехать вниз: ход --m-dur (0.35s) с запасом, .bsh-ov в cabinet.css
  }, [onClose]);
  // Escape — как у любой модалки кабинета.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [close]);
  if (typeof document === 'undefined') return null;
  const host = document.querySelector('.cab') ?? document.body;
  return createPortal(
    <div className={`bsh-ov${show ? ' show' : ''}`} onClick={close} role="presentation">
      <div className="bsh" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true" aria-label={title}>
        <div className="bsh-grab" aria-hidden />
        <div className="bsh-head">
          <KBareButton type="button" className="bsh-x" onClick={close} aria-label={t('close')}>
            <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.4} strokeLinecap="round" aria-hidden>
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
          </KBareButton>
          {title ? <div className="bsh-title">{title}</div> : null}
        </div>
        <div className="bsh-body">{typeof children === 'function' ? children(close) : children}</div>
      </div>
    </div>,
    host,
  );
}
